var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "evenodd",
    d: "M12.516 13.217l-1.76-2.184c-.36-.45-1.042-.55-1.545-.233-.52.333-.88.55-.97.6-.861.467-2.1-.883-3.196-2.633s-1.598-3.234-.736-3.684c.107-.05.484-.233 1.041-.483.539-.25.79-.833.557-1.35L4.74.75C4.542.317 4.04.067 3.536.133c-.682.1-1.418.35-1.778.534-2.047 1.1-1.778 5.5.809 9.633 2.568 4.117 6.483 6.433 8.53 5.35.36-.2.97-.667 1.401-1.167.305-.366.323-.9.018-1.266z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPhone);
export default __webpack_public_path__ + "static/media/contactPhone.b1b6435bb0fd9439ad304ca195a7c5df.svg";
export { ForwardRef as ReactComponent };